// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile_EqSwYk{max-width:600px;margin:auto;padding:0px 7px 50px}.profile__head_3-d-9V{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.profile__title_3uHzcJ{font-size:20px;margin-top:15px;font-family:\"Coustard\",monospace,serif}.profile__subtitle_2xkYU-{font-size:16px;margin:0 0 15px;color:#777}.profile__body_3XoXE6{margin-top:30px;margin:auto}.profile__noBets_2FEHdZ{font-size:16px;padding:60px 0 10px;text-align:center;color:#777}.tabber_3N22xH{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;font-size:16px}.tabber__tab_2jSMPn{padding:10px 10px;cursor:pointer;font-weight:normal;color:#666}.tabber__tab_2jSMPn:first-of-type{margin-right:30px}.tabber__tab_2jSMPn:hover{color:#000}.tabber__tab__selected_1CpaI4{font-weight:bold;color:#000}\n", ""]);
// Exports
exports.locals = {
	"profile": "profile_EqSwYk",
	"profile__head": "profile__head_3-d-9V",
	"profile__title": "profile__title_3uHzcJ",
	"profile__subtitle": "profile__subtitle_2xkYU-",
	"profile__body": "profile__body_3XoXE6",
	"profile__noBets": "profile__noBets_2FEHdZ",
	"tabber": "tabber_3N22xH",
	"tabber__tab": "tabber__tab_2jSMPn",
	"tabber__tab__selected": "tabber__tab__selected_1CpaI4"
};
module.exports = exports;
